import { type ReactElement, useId } from 'react';
import { cn } from '@/shared/ui';

/** 설정이 완료된 경우에만 카드형 라디오 선택지를 표시한다. */
export const PaymentMethodChoice = ({
  value,
  onChange,
  bankAvailable,
}: {
  readonly value: 'CARD' | 'BANK_TRANSFER';
  readonly onChange: (value: 'CARD' | 'BANK_TRANSFER') => void;
  readonly bankAvailable: boolean;
}): ReactElement | null => {
  const name = useId();
  if (!bankAvailable) return null;
  return (
    <fieldset className="flex flex-col gap-3">
      <legend className="mb-3 text-sm font-medium">결제 방법</legend>
      <div className="grid gap-3 sm:grid-cols-2">
        {(
          [
            { value: 'CARD', label: '카드·간편결제' },
            { value: 'BANK_TRANSFER', label: '계좌이체' },
          ] as const
        ).map((option) => (
          <label
            key={option.value}
            className={cn(
              'flex min-h-14 cursor-pointer items-center gap-3 rounded-2xl border px-4 py-3 text-sm transition-colors',
              value === option.value
                ? 'border-foreground'
                : 'border-input hover:border-foreground/40',
            )}
          >
            <input
              type="radio"
              name={name}
              value={option.value}
              checked={value === option.value}
              onChange={() => onChange(option.value)}
              className="size-4 accent-primary focus-visible:ring-2 focus-visible:ring-ring"
            />
            <span className="font-medium">{option.label}</span>
          </label>
        ))}
      </div>
    </fieldset>
  );
};
